import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAmountDown } from '@fortawesome/pro-light-svg-icons';

const SortingIcon = ({ className = '', ...rest }) => {
  return (
    <FontAwesomeIcon icon={faSortAmountDown} {...rest} className={className} />
  );
};

export default SortingIcon;
